import { render, staticRenderFns } from "./remarks-list-pooup.html?vue&type=template&id=bc0c33ea&scoped=true&external"
import script from "./remarks-list-pooup.js?vue&type=script&lang=js&external"
export * from "./remarks-list-pooup.js?vue&type=script&lang=js&external"
import style0 from "./remarks-list-pooup.scss?vue&type=style&index=0&id=bc0c33ea&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0c33ea",
  null
  
)

export default component.exports